import "./_instagram-slider-styles.scss";

 import './instagram-slider';
